import React from "react";
import "./Header.css";
import { Link } from "react-router-dom";
import SearchIcon from "@material-ui/icons/Search";
import ShoppingBasketIcon from "@material-ui/icons/ShoppingBasket";
import { useStateValue } from "./Context";
import { auth } from "./firebase";
// import img from './Amazone-icon.png'

export default function Header() {
 const[{basket, user}, dispatch]= useStateValue()

const handleAuthentication= ()=>{
  if(user){
    auth.signOut();
  }
}

  return (
    <div className="header">
      <Link to='/' >
      <img
        src="http://pngimg.com/uploads/amazon/amazon_PNG11.png"
        alt=""
        className="header_logo"
        />
        </Link>

      <div className="header_search">
        <input className="header_searchInput" type="text" placeholder="Search your items....." />
        <SearchIcon className="header_searchIcon" />
      </div>

      <div className="header_nav">
          <Link to = {!user && '/login' }  >
        <div onClick={handleAuthentication}  className="header_option">
          <span className="header_optionLineone">Hello {!user? "Guest": user.email}</span>
          <span className="header_optionLinetwo">{user? 'Sign Out':'Sign In'}</span>
        </div>
          </Link>
     <Link  to='/orders'>
        <div className="header_option">
          <span className="header_optionLineone">Returns</span>
          <span className="header_optionLinetwo">& Orders</span>
        </div>
     </Link>
        <div className="header_option">
          <span className="header_optionLineone">Your</span>
          <span className="header_optionLinetwo">Prime</span>
        </div>
        <Link to='/checkout'>
        <div className="header_basket" > 
        <ShoppingBasketIcon className="header_basketIcon" />
        <span className="header_optionLinetwo header_basketCount" >{basket?.length}</span>
         </div>
        </Link>
      </div>
    </div>
  );
}
